import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
} from "reactstrap"
import { get, put, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import Loader from "common/loader"
import {
  SHOW_ARTICLE,
  UPDATE_ARTICLE,
  LANGUAGES_SEARCH,
  UPLOAD_FILE,
} from "helpers/api_endpoints"
import MapComponent from "../../components/Common/Map"
import Select from "react-select"

document.title = "Edit Articles"

function EditArticle() {
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const [id, setid] = useState("")
  const [name, setName] = useState("")
  const [status, setStatus] = useState(0)
  const [named, setNamed] = useState({ title: [] })
  const [image, setImage] = useState("")
  const [selectedFile, setSelectedFile] = useState(null)
  const fileInputRef = useRef(null)
  const [articalePharagraph, setArticalePharagraph] = useState([])
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    const getArticle = async () => {
      try {
        setLoading(true)
        const response = await get(`${SHOW_ARTICLE}/${params.id}`)
        const data = response.data
        setid(params.id)
        setName(data.name)
        setStatus(data.status)
        setNamed(data.named)
        setImage(data.image)
        setArticalePharagraph(
          data.ArticleParagraphs.map(p => ({
            ...p,
            named: typeof p.named === "string" ? JSON.parse(p.named) : p.named,
            contented:
              typeof p.contentd === "string"
                ? JSON.parse(p.contentd)
                : p.contentd,
          }))
        )
      } catch (error) {
        setLoading(false)
        console.error("Error fetching article:", error)
      } finally {
        setLoading(false)
      }
    }
    getArticle()
  }, [params.id])

  useEffect(() => {
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const handleSubmit = e => {

    if (errorMsg) {
    return
  }
    setLoading(true)

    const paragraphs = articalePharagraph.map(p => ({
      ...p,
      // Stringify 'named' (title) for the `name` field
      name: p.named ? JSON.stringify(p.named) : "",
      // NEW: Stringify 'contented' (content) for the `content` field
      content: p.contented ? JSON.stringify(p.contented) : "",
    }))

    const formData = {
      id,
      name: JSON.stringify(named),
      status,
      image,
      named,
      ArticleParagraphs: paragraphs,
    }

    put(UPDATE_ARTICLE, formData)
      .then(response => {
        if (response.code === 200) {
          navigate("/articles", {
            state: { successMsg: "Article Updated Successfully" },
          })
        }
      })
      .catch(error => {
        console.error("Error updating article:", error)
        seterrorMsg("Failed to update article. Please try again.")
      })
      .finally(() => setLoading(false))
  }

  const handleName = (languageId, value) => {
    if (!named.title) {
      const ob = {}
      ob[languageId] = value
      setNamed({ title: [ob] })
      return
    }
    const ln = named.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      named.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(named))
  }

  const handleFileUpload = event => {
    const file = event.target.files[0]
    if (!file) return

    if (file.size > 1 * 1024 * 1024) {
      seterrorMsg("File size is larger than 1MB")
      setSelectedFile(null)
      setImage("")
      if (fileInputRef.current) fileInputRef.current.value = ""
      return
    }
    if (file.type !== "image/jpeg" && file.type !== "image/png") {
      seterrorMsg("Only JPEG or PNG images are allowed")
      setSelectedFile(null)
      if (fileInputRef.current) fileInputRef.current.value = ""
      return
    }
    seterrorMsg("")
    setSelectedFile(file)

    post(
      `${UPLOAD_FILE}`,
      { file, type: "article_image", fullPath: "true" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then(response => {
        const data = response.data
        setImage(data.path)
      })
      .catch(error => {
        console.error("Upload error:", error)
        seterrorMsg("File upload failed.")
        setSelectedFile(null) // Clear preview on error
      })
  }

  const clearPhoto = () => {
    setSelectedFile(null)
    setImage("")
    seterrorMsg("")
    if (fileInputRef.current) fileInputRef.current.value = ""
  }

  const clearParagraphPhoto = index => {
    setArticalePharagraph(prev => {
      const updated = [...prev]
      updated[index].image = ""
      return updated
    })
  }

  const handleParagraphChange = (index, field, value) => {
    setArticalePharagraph(prev => {
      const updated = [...prev]
      updated[index] = { ...updated[index], [field]: value }
      return updated
    })
  }

  const handleParagraphImage = async (index, file) => {
    if (!file) return

    try {
      const response = await post(
        UPLOAD_FILE,
        { file, type: "paragraph_image", fullPath: "true" },
        { headers: { "Content-Type": "multipart/form-data" } }
      )

      setArticalePharagraph(prev => {
        const updated = [...prev]
        updated[index].image = response.data.path
        return updated
      })
    } catch (err) {
      console.error("Paragraph Image Upload Error:", err)
    }
  }

  const deleteParagraph = index => {
    setArticalePharagraph(prev => prev.filter((_, i) => i !== index))
  }

  const addNewParagraph = () => {
    const newParagraph = {
      id: null, // backend will create it
      name: "",
      content: "",
      image: null,
      articleId: id, // optional but helpful
    }

    setArticalePharagraph(prev => [...prev, newParagraph])
  }

  const getLanguageValue = langId => {
    const item = named.title?.find(obj => obj[langId] !== undefined)
    return item ? item[langId] : ""
  }

  const getParagraphLangValue = (paragraph, langId, field = "named") => {
    const data = paragraph[field]
    if (!data || !data.title || !Array.isArray(data.title)) return ""
    const item = data.title.find(obj => obj[langId] !== undefined)
    return item ? item[langId] : ""
  }

  const handleParagraphLangChange = (index, langId, value, field) => {
    setArticalePharagraph(prev => {
      const updated = [...prev]
      const paragraph = { ...(updated[index] || {}) }

      const targetField = paragraph[field] || { title: [] }
      if (!Array.isArray(targetField.title)) targetField.title = []

      const arr = [...targetField.title]
      const key = String(langId)
      const i = arr.findIndex(obj => obj && obj.hasOwnProperty(key))

      if (i === -1) arr.push({ [key]: value })
      else arr[i] = { [key]: value }

      targetField.title = arr
      paragraph[field] = targetField
      updated[index] = paragraph
      return updated
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Countries" breadcrumbItem="Edit City" />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {errorMsg ? (
                        <Alert color="danger">{errorMsg}</Alert>
                      ) : null}

                      {languages.map((language, index) => (
                        <Row key={language.id}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Name ({language.name})</Trans>
                            </Label>
                            <Input
                              value={getLanguageValue(language.id)}
                              className="form-control"
                              placeholder="Enter  Name"
                              type="text"
                              onChange={e =>
                                handleName(language.id, e.target.value)
                              }
                              required={
                                language.id == 1 || language.id == 2
                                  ? true
                                  : false
                              }
                            ></Input>
                          </div>
                        </Row>
                      ))}
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <select
                          className="form-control"
                          onChange={e => setStatus(e.target.value)}
                          required
                        >
                          <option value=""></option>
                          <option value={1} selected={status == 1}>
                            <Trans>Active</Trans>
                          </option>
                          <option value={0} selected={status == 0}>
                            <Trans>Non Active</Trans>
                          </option>
                        </select>
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Main Image</Trans>
                        </Label>
                        <Input
                          name="image"
                          className="form-control"
                          placeholder="Enter Symbol"
                          type="file"
                          onChange={handleFileUpload}
                          required={!image && !selectedFile}
                        ></Input>
                      </div>
                      {/* show the selected image */}
                      {(selectedFile || image) && (
                        <div>
                          <button
                            className="btn btn-danger mb-2 mx-2"
                            type="button"
                            onClick={clearPhoto}
                          >
                            Remove Image
                          </button>
                          <img
                            src={
                              selectedFile
                                ? URL.createObjectURL(selectedFile)
                                : image
                            }
                            width="500"
                            height="500"
                            alt="image Preview"
                          />
                        </div>
                      )}
                    </Row>

                    <Row>
                      {articalePharagraph && (
                        <div className="mt-4">
                          <h4>Article Paragraphs</h4>

                          <Button
                            color="primary"
                            className="mb-3"
                            onClick={addNewParagraph}
                          >
                            + Add Paragraph
                          </Button>

                          {articalePharagraph.map((item, index) => (
                            <Card
                              key={item.id || `new-${index}`}
                              className="mb-3"
                            >
                              <CardBody>
                                {/* DELETE BUTTON */}
                                <div className="d-flex justify-content-end">
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => deleteParagraph(index)}
                                  >
                                    Delete Paragraph
                                  </Button>
                                </div>
                                {languages.map(lang => (
                                  <Col
                                    md={4}
                                    key={`para-${index}-lang-${lang.id}`}
                                  >
                                    <Label>Title {lang.name}</Label>
                                    <Input
                                      type="text"
                                      value={getParagraphLangValue(
                                        item,
                                        lang.id
                                      )}
                                      onChange={e =>
                                        handleParagraphLangChange(
                                          index,
                                          lang.id,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Col>
                                ))}
                                <Row>
                                  {languages.map(lang => (
                                    <Col
                                      md={4}
                                      key={`para-content-${index}-lang-${lang.id}`}
                                      className="mt-2"
                                    >
                                      <Label>Content ({lang.name})</Label>
                                      <Input
                                        type="textarea"
                                        value={getParagraphLangValue(
                                          item,
                                          lang.id,
                                          "contented"
                                        )}
                                        onChange={e =>
                                          handleParagraphLangChange(
                                            index,
                                            lang.id,
                                            e.target.value,
                                            "contented"
                                          )
                                        }
                                      />
                                    </Col>
                                  ))}

                                  <Col md={4} className="mt-3">
                                    <Label>Paragraph Image</Label>
                                    <Input
                                      type="file"
                                      onChange={e =>
                                        handleParagraphImage(
                                          index,
                                          e.target.files[0]
                                        )
                                      }
                                      className="mb-2"
                                    />
                                    {item.image && (
                                      <div className="d-flex flex-column align-items-start">
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm mb-2"
                                          onClick={() =>
                                            clearParagraphPhoto(index)
                                          }
                                        >
                                          Remove Image
                                        </button>
                                        <img
                                          src={item.image}
                                          alt="paragraph"
                                          className="img-fluid"
                                          width={500}
                                          height={500}
                                        />
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          ))}
                        </div>
                      )}
                    </Row>

                    <div className="text-center  mt-4">
                      <Button type="submit" color="danger" disabled={loading}>
                        {loading ? (
                          <Trans>Loading...</Trans>
                        ) : (
                          <Trans>Submit</Trans>
                        )}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl={12}>
                <Row></Row>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditArticle
